import { MesfModal } from "@dexteel/mesf-core";
import { Box, Button, Typography } from "@mui/material";

interface Props {
	open: boolean;
	/** e.g. "(Angle) L3x3x1/4" */
	productLabel: string;
	/** e.g. "Night setup · v4" */
	recipeLabel: string;
	busy?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

// Making a recipe current changes the setup the operators straighten against,
// so both screens that can do it ask first with the same wording.
export const SetCurrentRecipeModal = ({
	open,
	productLabel,
	recipeLabel,
	busy = false,
	onConfirm,
	onCancel,
}: Props) => (
	<MesfModal
		id="straightener-set-current"
		title="Set as default recipe?"
		open={open}
		handleClose={onCancel}
		maxWidth="sm"
	>
		<MesfModal.Content dividers style={{ padding: "15px 30px" }}>
			<Typography>
				<strong>{recipeLabel}</strong> becomes the default recipe for{" "}
				<strong>{productLabel}</strong>. It is the setup the straightener is run
				against from now on.
			</Typography>
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "flex-end",
					gap: 2,
					width: "100%",
				}}
			>
				<Button variant="contained" color="inherit" onClick={onCancel}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="success"
					disabled={busy}
					onClick={onConfirm}
				>
					Set as default
				</Button>
			</Box>
		</MesfModal.Actions>
	</MesfModal>
);
